/* import __COLOCATED_TEMPLATE__ from './site-modal.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { closeModal } from 'sh-www/utils/modal-controls';

import clsx from 'clsx';

class SiteModal extends Component {
  get opacity() {
    return this.args.opacity ?? 0.5;
  }

  get dismissible() {
    return this.args.isDismissible ?? true;
  }

  get classNames() {
    return clsx(
      this.args.class,
      'modal',
      this.args.fixedFooter && 'modal-fixed-footer',
    );
  }

  @action
  onClickOverlay() {
    if (!this.dismissible) return;

    // close the modal
    closeModal(this);
  }
}

export default SiteModal;
